import React from 'react';
import Loading from '../components/Loading';
import Messaging from '../components/Messaging';
import { useDietitianData } from '../hooks/useDietitianData';

const DietitianMessagesPage: React.FC = () => {
  const { dietitianId, userEmail, dietitian } = useDietitianData({
    fetchClients: false,
    fetchAppointments: false,
    fetchDietPrograms: false,
  });

  if (!dietitianId) {
    return (
      <Loading
        size="large"
        variant="wave"
        mode="inline"
        message="Mesajlar yükleniyor..."
      />
    );
  }

  const currentUserName = dietitian ? `${dietitian.firstName} ${dietitian.lastName}` : userEmail;

  return (
    <Messaging
      currentUserId={dietitianId}
      currentUserName={currentUserName}
      isDietitian={true}
    />
  );
};

export default DietitianMessagesPage;
